import React from "react";
import moment from "moment";
import editIcon from "./edit.png";
import "./styles.css";

class User extends React.Component {
  state = {
    showAffiliateInfo: false,
    specialCommission: null,
    salesThisMonth: null,
    averageMonthlySales: null,
    currentCommission: null,
  };

  componentDidMount() {
    if (this.props.affiliate) this.monthlyAverageLogic();
  }

  onFreeClick = (uid, idToken, premium, search) => {
    if (premium) {
      fetch(
        "https://us-central1-project-1029735015520686877.cloudfunctions.net/adminSearchUsers",
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            setUserFree: uid,
            idToken,
          }),
        }
      ).then(() => {
        search();
      });
    }
  };

  onPremiumClick = (uid, idToken, premium, cyclone, search) => {
    if (!premium || (cyclone && premium)) {
      fetch(
        "https://us-central1-project-1029735015520686877.cloudfunctions.net/adminSearchUsers",
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            setUserPremium: uid,
            idToken,
          }),
        }
      ).then(() => {
        search();
      });
    }
  };

  onCycloneClick = (uid, idToken, cyclone, search) => {
    if (!cyclone) {
      fetch(
        "https://us-central1-project-1029735015520686877.cloudfunctions.net/adminSearchUsers",
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            setUserCyclone: uid,
            idToken,
          }),
        }
      ).then(() => {
        search();
      });
    }
  };

  affiliateChange = (uid, token, action, search) => {
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/generateAffiliateLink?uid=${uid}&token=${token}&action=${action}`,
      {
        mode: "no-cors",
      }
    )
      .then(() => search())
      .catch((err) => console.log(err));
  };

  resetMachineId = (uid, token, search) => {
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/resetMachineId?uid=${uid}&idToken=${token}`,
      {
        mode: "no-cors",
      }
    ).catch((err) => console.log(err));
  };

  flag = (uid, token, search, undo) => {
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/redFlag?uid=${uid}&idToken=${token}&undo=${undo}`,
      {
        mode: "no-cors",
      }
    )
      .then(() => search())
      .catch((err) => console.log(err));
  };

  processTriggerLogsData = (triggerLogs) => {
    const logs = [];
    if (triggerLogs) {
      // eslint-disable-next-line guard-for-in
      for (let i in triggerLogs) {
        const date = new Date(parseInt(i)).toUTCString().substr(0, 25);
        logs.push({
          date,
          ...triggerLogs[i],
        });
      }
    }
    return logs.sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
  };

  monthlyAverageLogic = () => {
    const date = new Date();
    const date2 = new Date();
    const currentUTCDay = date.getUTCDate();
    const UTCMonthAndYear =
      date.getUTCMonth().toString() + date.getUTCFullYear();
    date2.setMonth(date2.getMonth() - 1);
    const oldUTCMonthAndYear =
      date2.getUTCMonth().toString() + date2.getUTCFullYear();
    if (this.props.affiliate.monthlySales) {
      // eslint-disable-next-line radix
      let slicedMonth = parseInt(oldUTCMonthAndYear.slice(0, -4));
      // eslint-disable-next-line radix
      let slicedYear = parseInt(oldUTCMonthAndYear.slice(-4));
      let joinedMonthYear = slicedMonth.toString() + slicedYear;
      let extraMonths = 0;

      while (
        !this.props.affiliate.monthlySales[joinedMonthYear] &&
        this.props.affiliate.monthlySales[joinedMonthYear] !== 0
      ) {
        if (
          Object.keys(this.props.affiliate.monthlySales).length === 1 &&
          this.props.affiliate.monthlySales[UTCMonthAndYear]
        ) {
          break;
        }
        extraMonths++;
        if (slicedMonth > 0) {
          slicedMonth--;
        } else {
          slicedMonth = 11;
          slicedYear--;
        }
        joinedMonthYear = slicedMonth.toString() + slicedYear;
      }

      let totalSales = 0;
      // eslint-disable-next-line guard-for-in
      for (let i in this.props.affiliate.monthlySales) {
        totalSales += this.props.affiliate.monthlySales[i];
      }
      let averageMonthlySales;
      let salesThisMonth;
      let currentCommission;
      const noOfMonths = Object.keys(this.props.affiliate.monthlySales).length;
      if (
        this.props.affiliate.monthlySales[UTCMonthAndYear] ||
        this.props.affiliate.monthlySales[UTCMonthAndYear] === 0
      ) {
        if (noOfMonths === 1) {
          averageMonthlySales = totalSales / (noOfMonths + extraMonths);
        } else {
          averageMonthlySales =
            totalSales / (noOfMonths + extraMonths - 1 + currentUTCDay * 0.033);
        }

        salesThisMonth = this.props.affiliate.monthlySales[UTCMonthAndYear];
      } else {
        averageMonthlySales =
          totalSales / (noOfMonths + extraMonths + currentUTCDay * 0.033);

        salesThisMonth = 0;
      }
      averageMonthlySales = Math.round(averageMonthlySales);
      if (averageMonthlySales >= 5) {
        currentCommission = "30%";
      }
      if (averageMonthlySales >= 10) {
        currentCommission = "40%";
      }
      if (averageMonthlySales >= 15) {
        currentCommission = "50%";
      }
      this.setState({
        salesThisMonth,
        averageMonthlySales,
        currentCommission,
      });
    } else {
      this.setState({
        salesThisMonth: 0,
        averageMonthlySales: 0,
        currentCommission: "20%",
      });
    }
  };

  getCommission = () => {
    if (this.props.specialCommission) {
      return this.props.specialCommission + "%";
    } else if (this.state.currentCommission) {
      return this.state.currentCommission;
    } else {
      return "20%";
    }
  };

  render() {
    const {
      name,
      email,
      uid,
      photoURL,
      joined,
      lastSignIn,
      premium,
      cyclone,
      search,
      idToken,
      affiliate,
      affiliatedBy,
      paypalMail,
      handleTriggerLogsModal,
      handleModal,
      editAffiliateInfoModal,
      modalYesAction,
      modalYesClicked,
      concernedEmail,
      triggerLogs,
      redFlag,
    } = this.props;

    if (modalYesClicked && email === concernedEmail) {
      switch (modalYesAction) {
        case "setfree":
          this.onFreeClick(uid, idToken, premium, search);
          break;
        case "setpremium":
          this.onPremiumClick(uid, idToken, premium, cyclone, search);
          break;
        case "setcyclone":
          this.onCycloneClick(uid, idToken, cyclone, search);
          break;
        case "setaffiliate":
          this.affiliateChange(uid, idToken, "affyes", search);
          break;
        case "unsetaffiliate":
          this.affiliateChange(uid, idToken, "affno", search);
          break;
        case "resetmachineid":
          this.resetMachineId(uid, idToken, search);
          break;
        case "redflag":
          this.flag(uid, idToken, search, null);
          break;
        case "redflagundo":
          this.flag(uid, idToken, search, "undo");
          break;
        default:
          console.log("Unknow action");
      }
      handleModal("close");
    }

    return (
      <div className={redFlag === "refunded" ? "user flagged" : "user"}>
        <div className="userinfo">
          <div className="nameandphoto">
            <img src={photoURL} alt="avatar" /> <span>{name}</span>
          </div>
          {affiliate && (
            <div className="showaffiliateinfobutton">
              <div
                className={
                  this.state.showAffiliateInfo
                    ? "usercontrolbutton active"
                    : "usercontrolbutton"
                }
                onClick={() =>
                  this.setState((prevState) => ({
                    showAffiliateInfo: prevState.showAffiliateInfo
                      ? false
                      : true,
                  }))
                }
              >
                Show Affiliate Info
              </div>
            </div>
          )}
          <div>Email: {email}</div>
          <div>UID: {uid}</div>
          <div>Joined: {moment(joined).format("h:hh A DD MMM YYYY")}</div>
          <div>
            Last Logged In: {moment(lastSignIn).format("h:hh A DD MMM YYYY")}
          </div>
          {paypalMail ? <div>Paypal Email: {paypalMail}</div> : null}
          {affiliatedBy ? <div>Affiliated By: {affiliatedBy}</div> : null}
          {affiliate ? (
            <div>Affiliate Balance: ${affiliate.balance}</div>
          ) : null}
          {affiliate ? <div>Total Earned: ${affiliate.totalearned}</div> : null}
          {affiliate ? (
            <div>Affiliate Sales: {affiliate.conversions}</div>
          ) : null}
          {affiliate ? <div>Affiliate Clicks: {affiliate.clicks}</div> : null}
        </div>
        {this.state.showAffiliateInfo && affiliate ? (
          <div className="affiliateprofile">
            <h2>
              Affiliate Profile{" "}
              <img
                src={editIcon}
                onClick={() => {
                  editAffiliateInfoModal({
                    name,
                    email,
                    uid,
                    affiliate,
                  });
                }}
                alt="edit"
              />
            </h2>
            <div>
              <span>AID:</span> {affiliate.aid}
            </div>
            <div>
              <span>Affiliate Balance:</span> ${affiliate.balance}
            </div>
            <div>
              <span>Total Earned:</span> ${affiliate.totalearned}
            </div>
            <div>
              <span>Affiliate Sales:</span> {affiliate.conversions}
            </div>
            <div>
              <span>Affiliate Clicks:</span> {affiliate.clicks}
            </div>
            <div>
              <span>Sales This Month:</span> {this.state.salesThisMonth}
            </div>
            <div>
              <span>Avg. Monthly Sales:</span> {this.state.averageMonthlySales}
            </div>
            <div>
              <span>Commission Rate:</span> {this.getCommission()}
            </div>
          </div>
        ) : (
          <div className="usercontrol">
            <div className="usertype">
              <div
                className={
                  premium ? "usercontrolbutton" : "usercontrolbutton active"
                }
                onClick={() => premium && handleModal("open", "setfree", email)}
              >
                Free User
              </div>
              <div
                className={
                  premium && !cyclone
                    ? "usercontrolbutton active"
                    : "usercontrolbutton"
                }
                onClick={() =>
                  (premium && !cyclone) ||
                  handleModal("open", "setpremium", email)
                }
              >
                Premium User
              </div>
              <div
                className={
                  cyclone ? "usercontrolbutton active" : "usercontrolbutton"
                }
                onClick={() =>
                  cyclone || handleModal("open", "setcyclone", email)
                }
              >
                Premium + Cyclone
              </div>
            </div>
            <div className="affiliatecontrol">
              <div
                className={
                  affiliate ? "usercontrolbutton" : "usercontrolbutton active"
                }
                onClick={() =>
                  affiliate && handleModal("open", "unsetaffiliate", email)
                }
              >
                Normal User
              </div>
              <div
                className={
                  affiliate ? "usercontrolbutton active" : "usercontrolbutton"
                }
                onClick={() =>
                  affiliate || handleModal("open", "setaffiliate", email)
                }
              >
                Affiliate Partner
              </div>
            </div>
            <div
              className="resetmachineid"
              onClick={() => handleModal("open", "resetmachineid", email)}
            >
              Reset Machine ID
            </div>
            {redFlag === "refunded" ? (
              <div
                className="resetmachineid"
                onClick={() => handleModal("open", "redflagundo", email)}
              >
                Undo Red Flag
              </div>
            ) : (
              <div
                className="resetmachineid"
                onClick={() => handleModal("open", "redflag", email)}
              >
                Red Flag
              </div>
            )}
            <div
              className="resetmachineid"
              onClick={() =>
                handleTriggerLogsModal(
                  "open",
                  this.processTriggerLogsData(triggerLogs)
                )
              }
            >
              View Trigger Logs
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default User;



/** WEBPACK FOOTER **
 ** ./src/views/pages/admin/sections/users/components/user/index.js
 **/